import updateUrlParameter from "./updateUrlParameter";
import formatQueryString from "./formatQueryString";
import normalizeUrlSlashes from "./normalizeUrlSlashes";

function updateUrlParameters(pathname, props) {
    let newPathname = pathname;
    Object.keys(props).forEach(key => {
        newPathname = updateUrlParameter(newPathname, key, props[key]);
    });
    return newPathname;
}

export default {
    updateUrlParameters: updateUrlParameters,
    formatQueryString: formatQueryString,
    normalizeUrlSlashes: normalizeUrlSlashes
};
